import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Link, Divider } from '@olxbr/ds-web';
import { ExternalLink, Video } from '@olxbr/ds-icons';
import { clickOpenLinkSecurityModal } from '../../../helpers/lurker';
export function RedirectButtons(_ref) {
  var content = _ref.content,
    idPage = _ref.idPage;
  var handleOpenURL = function handleOpenURL(link) {
    clickOpenLinkSecurityModal({
      link: link,
      idPage: idPage,
      'id-card': content.id
    });
  };
  return /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "space-between",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "space-around",
    flexDirection: "row"
  }, /*#__PURE__*/React.createElement(Link, {
    onClick: function onClick() {
      return handleOpenURL(content.redirectLink);
    },
    href: content.redirectLink,
    iconLeft: /*#__PURE__*/React.createElement(ExternalLink, {
      size: "16px"
    }),
    target: "_blank",
    marginTop: "--spacing-1",
    marginBottom: "--spacing-1"
  }, content.redirectText), (content === null || content === void 0 ? void 0 : content.redirectLinkVideo) && /*#__PURE__*/React.createElement(Link, {
    onClick: function onClick() {
      return handleOpenURL(content.redirectLinkVideo);
    },
    href: content.redirectLinkVideo,
    iconLeft: /*#__PURE__*/React.createElement(Video, {
      size: "16px"
    }),
    target: "_blank",
    marginTop: "--spacing-1",
    marginBottom: "--spacing-1"
  }, content.redirectTextVideo)));
}
RedirectButtons.propTypes = {
  idPage: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired
};
export default RedirectButtons;